/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SILDiscountApplied
 */
export interface SILDiscountApplied {
    /**
     * 
     * @type {string}
     * @memberof SILDiscountApplied
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof SILDiscountApplied
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof SILDiscountApplied
     */
    fixPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof SILDiscountApplied
     */
    minimumQuantityNeeded?: number;
    /**
     * 
     * @type {number}
     * @memberof SILDiscountApplied
     */
    quantityOrdered?: number;
    /**
     * 
     * @type {number}
     * @memberof SILDiscountApplied
     */
    minimumApplicableQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof SILDiscountApplied
     */
    discountSourceId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SILDiscountApplied
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SILDiscountApplied
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof SILDiscountApplied
     */
    discountRowType?: SILDiscountAppliedDiscountRowTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SILDiscountApplied
     */
    assortmentNode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SILDiscountApplied
     */
    isNettable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SILDiscountApplied
     */
    isApplied?: boolean;
}


/**
 * @export
 */
export const SILDiscountAppliedDiscountRowTypeEnum = {
    Appropriation: 'APPROPRIATION',
    GreenOrdination: 'GREEN_ORDINATION',
    AgreementGroup: 'AGREEMENT_GROUP',
    CampaignPart: 'CAMPAIGN_PART',
    CampaignSalesPromotionPart: 'CAMPAIGN_SALES_PROMOTION_PART',
    CampaignSalesPromotionNode: 'CAMPAIGN_SALES_PROMOTION_NODE'
} as const;
export type SILDiscountAppliedDiscountRowTypeEnum = typeof SILDiscountAppliedDiscountRowTypeEnum[keyof typeof SILDiscountAppliedDiscountRowTypeEnum];


/**
 * Check if a given object implements the SILDiscountApplied interface.
 */
export function instanceOfSILDiscountApplied(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SILDiscountAppliedFromJSON(json: any): SILDiscountApplied {
    return SILDiscountAppliedFromJSONTyped(json, false);
}

export function SILDiscountAppliedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SILDiscountApplied {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'percentage': !exists(json, 'percentage') ? undefined : json['percentage'],
        'fixPrice': !exists(json, 'fixPrice') ? undefined : json['fixPrice'],
        'minimumQuantityNeeded': !exists(json, 'minimumQuantityNeeded') ? undefined : json['minimumQuantityNeeded'],
        'quantityOrdered': !exists(json, 'quantityOrdered') ? undefined : json['quantityOrdered'],
        'minimumApplicableQuantity': !exists(json, 'minimumApplicableQuantity') ? undefined : json['minimumApplicableQuantity'],
        'discountSourceId': !exists(json, 'discountSourceId') ? undefined : json['discountSourceId'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'discountRowType': !exists(json, 'discountRowType') ? undefined : json['discountRowType'],
        'assortmentNode': !exists(json, 'assortmentNode') ? undefined : json['assortmentNode'],
        'isNettable': !exists(json, 'isNettable') ? undefined : json['isNettable'],
        'isApplied': !exists(json, 'isApplied') ? undefined : json['isApplied'],
    };
}

export function SILDiscountAppliedToJSON(value?: SILDiscountApplied | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'percentage': value.percentage,
        'fixPrice': value.fixPrice,
        'minimumQuantityNeeded': value.minimumQuantityNeeded,
        'quantityOrdered': value.quantityOrdered,
        'minimumApplicableQuantity': value.minimumApplicableQuantity,
        'discountSourceId': value.discountSourceId,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'discountRowType': value.discountRowType,
        'assortmentNode': value.assortmentNode,
        'isNettable': value.isNettable,
        'isApplied': value.isApplied,
    };
}

